module.exports = "/_next/static/images/fed0e9027e61a4ed542acf39e1dfa0a6-pencil.svg";